import { FC } from "react";
import { Box, Checkbox, FormControl, IconButton, Tooltip, useTheme } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

type DataProps = {
    id: number
    name: string
    checked: boolean
    description?: string
    onClick: (id: number) => void
    onSelect: (id: number, checked: boolean) => void
    /** Oculta a borda inferior da última linha */
    isLast?: boolean
    /** Destaca a linha selecionada com fundo creme e borda dourada */
    isSelected?: boolean
}

export const ListWithInfo: FC<DataProps> = ({ id, name, description, checked, onClick, onSelect, isLast, isSelected }) => {
    const theme = useTheme()
    const trimmed = name.trim()
    const displayName = trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase()

    return (
        <Box
            onClick={() => onSelect(id, !checked)}
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                minHeight: 62,
                px: 2,
                py: 1,
                borderBottom: isLast ? "none" : `1px solid ${theme.palette.divider}`,
                backgroundColor: isSelected ? theme.palette.brand.cream : "transparent",
                transition: "background-color 0.15s",
                cursor: "pointer",
                "&:hover": { backgroundColor: isSelected ? theme.palette.brand.cream : theme.palette.brand.surface2 },
                "&:first-of-type": { borderRadius: "13px 13px 0 0" },
                "&:last-of-type": { borderRadius: "0 0 13px 13px" },
            }}
        >
            <FormControl onClick={(e) => e.stopPropagation()}>
                <Checkbox
                    size="small"
                    color="primary"
                    checked={checked}
                    onChange={(_, check) => onSelect(id, check)}
                    inputProps={{ "aria-label": `Selecionar ${name}` }}
                    sx={{
                        p: 0.5,
                        "& .MuiSvgIcon-root": {
                            fontSize: 21,
                            borderRadius: "6px",
                        },
                        "&.Mui-checked": {
                            color: "primary.main",
                        },
                    }}
                />
            </FormControl>

            {/* Nome completo; reticências só por CSS quando não couber na linha
                (o corte fixo em 20 caracteres escondia o nome das bases) */}
            <Box sx={{ flex: 1, ml: 1.5, minWidth: 0 }}>
                <Box
                    title={displayName}
                    sx={{ fontSize: "14px", fontWeight: 500, color: "text.primary", lineHeight: 1.3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                >
                    {displayName}
                </Box>
                {description &&
                    <Box sx={{ fontSize: "12px", color: "text.secondary", mt: 0.25, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {description}
                    </Box>
                }
            </Box>

            <Tooltip title="Informações" placement="bottom">
                <IconButton
                    size="small"
                    aria-label={`Informações de ${name}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        onClick(id);
                    }}
                    sx={{ width: 32, height: 32, borderRadius: "8px", color: "primary.main" }}
                >
                    <VisibilityIcon sx={{ fontSize: 20 }} />
                </IconButton>
            </Tooltip>
        </Box>
    )
}
